module.exports = __webpack_public_path__ + "media/images/app_logo/192-87af8d788d994fc4e6b9e7f80dc33f37.png";